// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6Xsoj","input":"styles_input__3tue7"};